import React, { useContext, useEffect } from 'react'
import Layout from 'components/layout'
import SEO from 'components/seo'
import { injectIntl } from 'gatsby-plugin-intl'
import { graphql } from 'gatsby'
import BackgroundImage from 'gatsby-background-image'
import styled from 'styled-components'
import { colors, breakpoints } from 'utils/utils'
import Img from 'gatsby-image'
import ScrollAnimation from 'react-animate-on-scroll'
import TypeWriterText from 'typewriter-effect'
import YoutubeVideo from 'components/YoutubeVideo'
import HeroContainer from 'components/heroContainer'
import { GlobalStateContext } from '../context/globalContext'
import { GlobalDispatchContext } from '../context/globalContext'

export default injectIntl( props => {

    const state = useContext(GlobalStateContext)
    const dispatch = useContext(GlobalDispatchContext)  
     
    useEffect(() => {
        if(state.otherLanguageSlug !== props.pageContext.otherLanguageSlug) {
            dispatch(state.changeOtherLanguageSlug(props.pageContext.otherLanguageSlug))
        }
    }, [state, dispatch, props.pageContext.otherLanguageSlug])

    const { data, media, seo, title, youtubeVideo } = props.data.contentfulSection

    const hero = media[0].fluid
    
    const office = media.map( (img, index) => {
        return ( (index > 0 && index <= 3) && <Image key={index} fluid={img.fluid}/> )
    })
    
    const videoId = youtubeVideo.youtubeId 

    const { videoTitle } = data

    const modular = () => {
        let modArray = [];
        for(let content in data) {
            if(content.includes("module")) {
                modArray.push(data[content]);
            }
        }
        let modules = [];
        for(let count = 0; count < modArray.length; count++) {
            if(count === 0 || count % 2 === 0) {
                modules.push(
                    <BlockModule key={count}>
                        <ScrollAnimation animateOnce={true} animateIn='fadeIn' offset={0} delay={200}>
                            <h2>{modArray[count]}</h2>
                            <span>{modArray[count + 1]}</span>
                        </ScrollAnimation>
                    </BlockModule>
                );
            }
        }
        return modules;
    }
    
    return (    
        <Layout>
            <SEO 
                title={seo.title}
                keywords={seo.attributes[0].keywords}
                slug={seo.slug}
                description={seo.attributes[0].description}
                lang={props.pageContext.language}
            />
            <Container>
                <HeroContainer>
                    <HeroLeft>
                        {/* <BackgroundImage fluid={hero} /> */}
                        <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
                            <Title>{title}</Title>
                        </ScrollAnimation>
                    </HeroLeft>
                    <HeroRight className="heroText">
                        <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
                            <div>{data.content1}</div>
                        </ScrollAnimation>
                    </HeroRight>
                </HeroContainer>
                <BlockVideo>
                    <AnimatedTypeText>
                        <h2>
                            <TypeWriterText 
                                options={{
                                    strings: videoTitle,
                                    autoStart: true,
                                    delay: 150,
                                    deleteSpeed: 150,
                                    loop: true,
                                }}
                            />
                        </h2>
                    </AnimatedTypeText>
                    <Video className="video">
                        <YoutubeVideo videoId={videoId} opts={{host: "https://www.youtube-nocookie.com"}}/>
                    </Video>
                </BlockVideo>
                <BlockPoints>
                    <BlockPoint>
                        <ScrollAnimation animateOnce={true} animateIn='fadeIn' delay={200}>
                            <h2>{data.content2title}</h2>
                            <span>{data.content2text}</span>
                        </ScrollAnimation>
                    </BlockPoint>
                    <BlockPoint>
                        <ScrollAnimation animateOnce={true} animateIn='fadeIn' delay={200}>
                            <h2>{data.content3title}</h2>
                            <span>{data.content3text}</span>
                        </ScrollAnimation>
                    </BlockPoint>
                    <BlockPoint>
                        <ScrollAnimation animateOnce={true} animateIn='fadeIn' delay={200}>
                            <h2>{data.content4title}</h2>
                            <span>{data.content4text}</span>
                        </ScrollAnimation>
                    </BlockPoint>
                </BlockPoints>
                <BlockImages>
                    <div>
                        {office}
                    </div>
                </BlockImages>
                <BlockModules>
                    <BackgroundImage fluid={hero} />
                    <BlockModulesGrid>
                        <h1>{data.content5}</h1>
                        <div>{modular()}</div>
                    </BlockModulesGrid>
                </BlockModules>
            </Container>
        </Layout>
    )
})

const Container = styled.div`
    background-color: ${colors.quinary};
`

const AnimatedTypeText = styled.div`
    width: 50%;
    background-color: ${colors.tertiary}; 
    ${breakpoints.md}{
        width: 100%;
        height: 20rem;
    }
    color: ${colors.quaternary};
    h2 {
        margin: auto;
        width: fit-content;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        font-size: 4rem;
        ${breakpoints.md}{
            font-size: 2.5rem;
        }
    }
`

const Video = styled.div`
    width: 50%;
    display: flex;
    background: ${colors.quaternary};
    ${breakpoints.md}{
        width: 100%;
    }
    video, iframe, & > div {
        width: 100%;
        height: 100%;
        min-height: 25rem;
    }
`

const BlockVideo = styled.div`
    display: flex;
    height: min-content;
    padding: 0;
 
    ${breakpoints.md}{
        flex-direction: column-reverse;
    }
`

const BlockModules = styled.div`    
    height: 35rem;
    margin: auto;
    text-align: center;
    background-color: rgba(255,255,153,0.1);
    position: relative;
    .gatsby-image-wrapper {
        opacity: 0.3!important;
        height: 100%;
        &:before {
            background-size: cover;
        }
        ${breakpoints.md}{
            display: none;
        }
    }
    h1 {
        font-size: 2.4rem;
    }
    ${breakpoints.md}{
        width: 100%;
        height: auto;
        background-color: ${colors.secondary};
    }  
`
const BlockModulesGrid = styled.div`
    padding: 1rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    
    > div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 53rem;
        margin: auto;
        ${breakpoints.md}{
            justify-content: space-evenly;
            width: 100%;
        }
    }

    ${breakpoints.md}{
        position: initial;
        transform: initial;
        color: ${colors.tertiary};
    }
`
    
const BlockModule = styled.div`
    width: 16.5rem;
    padding: 1rem .5rem 3rem;
    margin-bottom: 1rem;
    background-color: rgba(255,255,255,0.3);
    ${breakpoints.md}{
        width: 100%;
    }
    h2 {
        margin-bottom: 3rem;
        position: relative;
        &:before {
            content: '';
            position: absolute;
            bottom: -2rem;
            left: 50%;
            transform: translateX(-50%);
            height: .2rem;
            width: 3.5rem;
            background-color: ${colors.quaternary};
            z-index: 3;
            ${breakpoints.md}{
                background-color: ${colors.tertiary};
            }
        }
    }
`
const HeroLeft = styled.div `
    width: 50%;
    background-color: ${colors.secondary};
    display: flex;
    justify-content: center;
    align-items: center;ç
    .animated {
        div {
            max-width: 60%;
            margin: auto;
            white-space: pre-wrap;
            ${breakpoints.md}{
                max-width: 100%;
                height: 30rem;
            }
        }
        ${breakpoints.md}{
            position: initial;
            height: auto;
            width: 100%;
        }
    }
    ${breakpoints.md}{
        width: 100%;
        height: 30rem;
        h1 {
            font-size: 2.5rem;
        }
    }
`
const HeroRight = styled.div `
    width: 50%;
    ${breakpoints.md}{
        width: 100%;
    }
    .animated {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        div {
            max-width: 60%;
            margin: auto;
            white-space: pre-wrap;
            ${breakpoints.md}{
                max-width: 80%;
                padding: 6vh 0;
            }
        }
        ${breakpoints.md}{
            position: initial;
            height: auto;
            width: 100%;
        }
    }
`

const Image = styled(Img)`
    width: 33.3333%;
    height: auto;
    ${breakpoints.md}{
        width: 100%;
    } 
`

const BlockImages = styled.section`
    div {
        display: flex;
        flex-direction: row;
        ${breakpoints.ms}{
            flex-direction: column;
        }  
    }
`

const BlockPoints = styled.section`
    white-space: break-spaces;
    display: flex;
    height: 20rem;
    min-height: 20rem;
    justify-content: center;
    align-items: center;

    ${breakpoints.md}{
        min-height: 50rem;
        flex-direction: column;
    }
`

const BlockPoint = styled.div`
    padding: 0 2rem;
    width: 33.3333%;
    height: 100%;
    text-align: center;
    position: relative;
    font-weight: bold;
    background-color: ${colors.primary};
    color: ${colors.tertiary};
    div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    h2 {
        font-size: 2rem;
        margin-bottom: 1rem;
        position: relative;
        &:before {
            content: '';
            position: absolute;
            top: -2rem;
            left: 48%;
            height: 1rem;
            width: 1rem;
            background-color: ${colors.secondary};
            z-index: 3;
        }
        &:after {
            content: '';
            position: absolute;
            top: -1.7rem;
            left: 50%;
            height: 1rem;
            width: 1rem;
            background-color: ${colors.secondary};
            opacity: 0.4;
            z-index: 2;
        }
    }
    &:first-of-type {
        background-color: ${colors.quaternary};
        color: ${colors.tertiary};
        h2::before,
        h2::after {
            background-color: ${colors.tertiary};
        }
    }
    &:last-of-type {
        background-color: ${colors.secondary};
        color: ${colors.tertiary};
        h2::before,
        h2::after {
            background-color: ${colors.quaternary};
        }
    }
    ${breakpoints.md}{           
        width: 100%;
    }
`

const Title = styled.h1`
    font-size: 4rem;
    color: ${colors.tertiary};
    max-width: 70%;
    margin: auto;
    font-size 3.5rem;
    ${breakpoints.md} {
        margin: auto;
        max-width: 90%;
        text-align: center;
        font-size 2.5rem;
    }
`

export const query = graphql`
    query($language: String) {
        contentfulSection(name: {eq: "Empresa"}, node_locale: {eq: $language}) {
            id
            title
            seo {
                title
                slug
                attributes {
                    description
                    keywords
                }
            }
            data {
                content1
                content2title
                content2text
                content3title
                content3text
                content4title
                content4text
                content5
                module1title
                module1text
                module2title
                module2text
                module3title
                module3text
                module4title
                module4text
                module5title
                module5text
                module6title
                module6text
                videoTitle
            }
            cta {
                href
                value
            }
            media {
                title
                fluid(quality : 100){
                    ...GatsbyContentfulFluid_withWebp_noBase64
                }
                file {
                    url
                }
            }
            users {
                avatar {
                  file {
                    url
                  }
                  title
                }
                name
                position
            }
            youtubeVideo {                
                youtubeId
            }
        }
    }
`